var _rect, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVxx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "-50 -20 180 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -50,
    y: -20,
    width: 180,
    height: 120,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_181_3607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7892 25.8065C43.7086 25.8065 46.8859 22.6291 46.8859 18.7097C46.8859 14.7902 43.7086 11.6129 39.7892 11.6129C35.8697 11.6129 32.6924 14.7902 32.6924 18.7097C32.6924 22.6291 35.8697 25.8065 39.7892 25.8065Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4342 0C40.29 0 40.1482 0.00937 40.0044 0.01087C50.9497 0.12758 59.7891 9.02698 59.7891 20C59.7891 31.0457 50.8348 40 39.7891 40C28.7434 40 19.7891 48.9543 19.7891 60C19.7891 71.0457 28.7434 80 39.7891 80C39.8618 80 39.932 79.9899 40.0046 79.9891C40.1483 79.9906 40.2901 80 40.4342 80C62.5256 80 80.4342 62.0914 80.4342 40C80.4342 17.9086 62.5257 0 40.4342 0Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7892 67.0967C43.7086 67.0967 46.8859 63.9194 46.8859 60C46.8859 56.0805 43.7086 52.9032 39.7892 52.9032C35.8697 52.9032 32.6924 56.0805 32.6924 60C32.6924 63.9194 35.8697 67.0967 39.7892 67.0967Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_181_3607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.4346,
    height: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVxx);
export default __webpack_public_path__ + "static/media/VXX.9ed139c1e223c4c7b84475ae978a9277.svg";
export { ForwardRef as ReactComponent };